import { create } from 'zustand';

interface CanvasState {
  // Canvas metadata & control state
  canUndo: boolean;
  canRedo: boolean;
  zoomLevel: number;
  /** The canvas's selected figures, as its change:selection event gives them. */
  selection: unknown[];
  modified: boolean;
  /** Monotonic counter bumped on every command-stack change (execute/undo/redo).
   *  Subscribe to re-render panels whose data lives in mutable canvas objects. */
  commandTick: number;

  // Actions
  setCanUndo: (canUndo: boolean) => void;
  setCanRedo: (canRedo: boolean) => void;
  setZoomLevel: (zoomLevel: number) => void;
  setSelection: (selection: unknown[]) => void;
  setModified: (modified: boolean) => void;
  bumpCommandTick: () => void;
  
  // Bulk update (useful for canvas event syncing)
  syncFromCanvas: (updates: Partial<Pick<CanvasState, 'canUndo' | 'canRedo' | 'zoomLevel' | 'selection' | 'modified'>>) => void;
  
  // Reset
  reset: () => void;
}

const initialState = {
  canUndo: false,
  canRedo: false,
  zoomLevel: 100,
  selection: [],
  modified: false,
  commandTick: 0,
};

export const useCanvasStore = create<CanvasState>((set) => ({
  ...initialState,

  setCanUndo: (canUndo) => set({ canUndo }),
  setCanRedo: (canRedo) => set({ canRedo }),
  setZoomLevel: (zoomLevel) => set({ zoomLevel }),
  setSelection: (selection) => set({ selection }),
  setModified: (modified) => set({ modified }),
  bumpCommandTick: () => set((state) => ({ commandTick: state.commandTick + 1 })),

  syncFromCanvas: (updates) => set((state) => ({ ...state, ...updates })),

  reset: () => set(initialState),
}));
